var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.25H7.875V6.125H8.75V5.25ZM6.125 10.5H5.25V11.375H6.125V10.5ZM3.5 5.25H2.625V6.125H3.5V5.25ZM6.125 5.25H5.25V6.125H6.125V5.25ZM8.75 7H7.875V7.875H8.75V7ZM11.375 7H10.5V7.875H11.375V7ZM3.5 7H2.625V7.875H3.5V7ZM6.125 7H5.25V7.875H6.125V7ZM8.75 8.75H7.875V9.625H8.75V8.75ZM11.375 8.75H10.5V9.625H11.375V8.75ZM3.5 8.75H2.625V9.625H3.5V8.75ZM6.125 8.75H5.25V9.625H6.125V8.75ZM8.75 10.5H7.875V11.375H8.75V10.5ZM11.375 10.5H10.5V11.375H11.375V10.5ZM0 0.875V13.125H14V0.875H11.375V0H10.5V0.875H3.5V0H2.625V0.875H0ZM13.125 1.75V3.5H0.875V1.75H2.625V2.625H3.5V1.75H10.5V2.625H11.375V1.75H13.125ZM0.875 12.25V4.375H13.125V12.25H0.875Z",
    fill: "#56CD9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.68971e0c9f6776da8b54963cfc211962.svg";
export { ForwardRef as ReactComponent };